import { Component } from "react";
import { connect } from "react-redux";
import { deleteArOrPps } from "../../../redux/analyseRisques/analyseRisquesEditionActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import "../../../utils.css";
import FooterFixedOnScreen from "../../../containers/Layout/FooterFixedOnScreen";

class ValidatedSpp extends Component {
    deleteArOrPps() {
        this.props.deleteArOrPps(this.props.analyseRisques, this.props.activeUser, this.props.analysesRisques);
    }

    render() {
        let deleteBtnElement = (
            <div>
                <Fab onClick={this.deleteArOrPps.bind(this)} className="red-button div-center">
                    <Icon>delete</Icon>
                </Fab>
                <span className="floating-btn-text span-center">Supprimer</span>
            </div>
        );

        return (
            <FooterFixedOnScreen>
                <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-4 col-4">{deleteBtnElement}</div>
                </div>
            </FooterFixedOnScreen>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        analyseRisques: state.analyseRisques,
        analysesRisques: state.analysesRisques,
        riskTypes: state.riskTypes.types,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        submitOrEditAnalyseRisques: (analyseRisques, activeUser, moduleSpp, riskTypes, analysesRisquesState) =>
            dispatch(
                submitOrEditAnalyseRisques(analyseRisques, activeUser, moduleSpp, riskTypes, analysesRisquesState)
            ),
        deleteArOrPps: (analyseRisques, activeUser, analysesRisquesState) =>
            dispatch(deleteArOrPps(analyseRisques, activeUser, analysesRisquesState)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ValidatedSpp);
